/**
 * Created with IntelliJ IDEA.
 * User: gall
 * Date: 9/18/13
 * Time: 12:44 PM
 *
 * This widget is used to implement a time frame/range picker on the page.
 * It is a view that should be set in a container.
 * Its background is transparent.
 *
 * Options:
 *   selectedTimeframe - mandatory. object of structure: {startDate: "Y_M_D H-M-S", expirationDate: "Y_M_D H-M-S"}
 *   vent - mandatory. the event dispatcher object. should be of the module/controller - not of the application - which in its scope the dates/times events are triggered
 *   timezoneId - optional. if not set a "N/A" label will be displayed. String id of the site's timezone for example: Asia/Jerusalem.
 *   isEndDateCheckboxHidden - optional. boolean to hide/display the end date checkbox. default to false.
 *   isLimitEndDatePicker - optional. whether or not to enable limiting the minimum end date picker to max(startDate, today). default to false.
 *   isLimitStartDatePicker - optional. whether or not to enable limiting the max start date picker to expirationDate (end date). default to false.
 *   alternativeSaveBtnText - optional. enables setting a different text to the save button.
 *   isLimitFutureDates - optional. boolean to limit or not the dates in the date pickers till today. defaults to true.
 *                        it is in conflict with this.isLimitEndDatePicker, this.isLimitStartDatePicker there for is not consider if any of them is declared
 *   allTimesCheckboxLabel - optional. the text to set with the all times checkbox. defaults to null which will leave the text empty.
 *   endDateCheckboxLabel - optional. the text to set with the no end date checkbox. defaults to null which will leave the text empty.
 *   maxDaysForTimeframeLabel - optional. the text instead the no end checkbox (meaning they can't both be shown). defaults to null which will leave the text empty.
 *   maxDaysForTimeframeValue - optional. if set then once start/end date is picked a time range limit of this value will be imposed on the end/start date accordingly.
 *                              defaults to null which mean no limit will be imposed.
 *                              it is in conflict with this.isLimitEndDatePicker, this.isLimitStartDatePicker there for is not consider if any of them is declared
 *   showButtons - optional. define whether to show the button or not. defaults to true
 *   pastLimitDate - optional. a date in the past to limit the date pickers. defaults to null
 *
 * Example of use:
 *
 * var TimeFrame = require('ui/timeframe/Timeframe');
 * var timeframeView = new TimeFrame({
 *      selectedTimeFrame: {
 *          startDate: "2013_10_01 0:0:0",
 *          expirationDate: "2013_10_15 0:0:0"
 *      },
 *      vent: LEReporting.vent,
 *      timezoneId: LE.siteSettings.timeZoneSettings.getCurrentTimeZone(),
 *      isEndDateCheckboxHidden: true,
 *      isLimitEndDatePicker: false,
 *      isLimitStartDatePicker: false,
 *      alternativeSaveBtnText: LE.translator.translate("LEReporting.DB_SaveButtonAltText"),
 *      isLimitFutureDates: true,
 *      pastLimitDate: null,
 *      maxDaysForTimeframeLabel: "(Max 31 days)",
 *      maxDaysForTimeframeValue: 31
 * });
 *
 * this.dashboardLayout.timeframeRegion.show(timeframeView);
 *
 * //bind to the timeframe events
 * var that = this;
 * this.listenTo(LEReporting.vent, "TimeFrameView:Cancel", function () {
 *      that.hideTimefilter();
 * });
 *
 * this.listenTo(LEReporting.vent, "TimeFrameView:Save", function (timeFrame) {
 *      LE.logger.debug("DashboardViewController:_bind: The event was TimeFramePageView:Save");
 *
 *      LEReporting.cmTimeframeDate[Config.queryParameters.FROMDATE] = DateUtility.strToDateObj(timeFrame.startDate);
 *      LEReporting.cmTimeframeDate[Config.queryParameters.TODATE] = DateUtility.strToDateObj(timeFrame.expirationDate);
 *
 *      that.hideTimefilter();
 *      that.updateDataAccordingToNewTimeframe();
 * });
 *
 */

define(function (require) {
    "use strict";

    var DateUtility = require("utils/DateUtility");
    var template = require("ui/timeframe/templates/timeframe.tmpl");
    var Logger = require('logger');
    var Button = require("ui/button/Button");
    var InputField = require("ui/input-field/InputField");
    var Checkbox = require("ui/checkbox/Checkbox");
    var Dropdown = require("ui/dropdown/Dropdown");
    var DatePicker = require("ui/datepicker/DatePicker");
    var Marionette = require('marionette');
    var _ = require('underscore');
    var $ = require('jquery');

    var TimeFrame = Marionette.ItemView.extend({
        template: template,
        events: {
        },
        selectedTimeframe: null,
        vent: null,
        pickerLabelsEnum: {
            START: "start",
            END: "end"
        },

        initialize: function (options) {
            this.logger = Logger.getLogger('TimeFrame');
            this.logger.debug("TimeFrameView:init  ");
            this.vent = options.vent;
            this.container = options.container;
            this.selectedTimeframe = $.extend(true, {}, options.selectedTimeFrame);

            this.today = DateUtility.date2Str(new Date(), true);

            this.tommorow = new Date();
            this.tommorow.setDate(this.tommorow.getDate() + 1);
            this.tommorow = DateUtility.date2Str(this.tommorow, true);

            //time zone string id
            this.timezoneId = options.timezoneId || null;

            // Show button state
            this.showButtons = _.isUndefined(options.showButtons) ? true : options.showButtons;

            //display/hide endDateCheckbox
            this.isEndDateCheckboxHidden = options.isEndDateCheckboxHidden || false;

            //limit the min date to pick in the end date picker
            this.isLimitEndDatePicker = options.isLimitEndDatePicker || false;

            //limit the max date to pick in the start date picker
            this.isLimitStartDatePicker = options.isLimitStartDatePicker || false;

            //alternative text for the save button
            this.alternativeSaveBtnText = options.alternativeSaveBtnText || null;

            //boolean to limit or not the dates in the date pickers till today
            //it is in conflict with this.isLimitEndDatePicker, this.isLimitStartDatePicker there for is not consider if any of them is declared
            var isLimitFutureDates = !_.isUndefined(options.isLimitFutureDates) ? options.isLimitFutureDates : true;
            if (this.isLimitEndDatePicker || this.isLimitStartDatePicker) {
                isLimitFutureDates = false;
            }
            this.isLimitFutureDates = isLimitFutureDates;

            this.pastLimitDate = options.pastLimitDate || null;

            this.allTimesCheckboxLabel = options.allTimesCheckboxLabel || null;

            this.endDateCheckboxLabel = options.endDateCheckboxLabel || null;

            this.maxDaysForTimeframeLabel = options.maxDaysForTimeframeLabel || null;

            //inclusive - meaning that when using it for adding/subtracting days subtract 1 from it because the current date is one more day
            //it is in conflict with this.isLimitEndDatePicker, this.isLimitStartDatePicker there for is not consider if any of them is declared
            this.maxDaysForTimeframeValue = (this.isLimitEndDatePicker || this.isLimitStartDatePicker) ? null : (options.maxDaysForTimeframeValue || null);
        },
        ui: {
            timeframeContainer: ".timeframe-container",
            startDateInput: ".text-box-start-date",
            endDateInput: ".text-box-end-date",
            endDateCheckBox: ".checkbox-alltime",
            allTimeCheckBox: ".checkbox-all",
            fromDropDown: ".list-from",
            toDropDown: ".list-to",
            startDatePickerEl: ".start-date-picker-contatiner",
            endDatePickerEl: ".end-date-picker-contatiner",
            saveBtn: ".button-save",
            cancelBtn: ".button-cancel",
            maxDaysForTimeframeLabel: ".max-days-timeframe-label",
            timezoneContainer: ".timezone-container",
            timezoneValue: ".timezone-value",
            buttonsContainer: ".buttons-container"
        },

        uiComponents:{
            noEndDate:{
                type:Checkbox,
                options:{
                    checked: 'view._getNoEndDateChecked',
                    el: 'view.ui.endDateCheckBox',
                    tabindex: 1
                },
                events:{
                    "change":"_noEndDateChanged"
                }
            },
            allTime:{
                type:Checkbox,
                options:{
                    checked: 'view._getAllTimeChecked',
                    el: 'view.ui.allTimeCheckBox',
                    tabindex: 2
                },
                events:{
                    "change":"_allTimeChanged"
                }
            },
            fromTime:{
                type:Dropdown,
                options:{
                    name: 'fromTime',
                    selectedOption: 'view._getStartTime',
                    items: 'view._getHoursDropdownItems',
                    container: 'view.ui.fromDropDown',
                    tabindex: 3,
                    permutation: Dropdown.PERMUTATION.XX_SMALL1,
                    testCollision: true,
                    collisionWithinSelector: ".le-timeframe .timeframe-container",
                    enabled: 'view._getOperationHoursState'
                },
                events:{
                    "change":"_fromTimeChanged"
                }
            },
            toTime:{
                type:Dropdown,
                options:{
                    name: 'toTime',
                    selectedOption: 'view._getEndTime',
                    items: 'view._getHoursDropdownItems',
                    container: 'view.ui.toDropDown',
                    tabindex: 4,
                    permutation: Dropdown.PERMUTATION.XX_SMALL1,
                    testCollision: true,
                    collisionWithinSelector: ".le-timeframe .timeframe-container",
                    enabled: 'view._getOperationHoursState'
                },
                events:{
                    "change":"_toTimeChanged"
                }
            },
            startDatePicker:{
                type:DatePicker,
                options:{
                    el: 'view.ui.startDatePickerEl',
                    selectedDate: 'view.selectedTimeframe.startDate',
                    maxDate: 'view._getStartDatePickerMaxDate'
                },
                events:{
                    "dateselected":"_startDateChanged"
                }
            },
            endDatePicker:{
                type:DatePicker,
                options:{
                    el: 'view.ui.endDatePickerEl',
                    selectedDate: 'view.selectedTimeframe.expirationDate',
                    minDate: 'view._getEndDatePickerMinDate',
                    enabled: 'view._getEndDatePickerEnabledState'
                },
                events:{
                    "dateselected":"_endDateChanged"
                }
            },
            saveBtn:{
                type:Button,
                options:{
                    el: 'view.ui.saveBtn',
                    permutation: Button.PERMUTATION.BTN_PRIMARY,
                    initState: Button.STATES.ENABLED
                },
                events:{
                    "click":"onSaveButtonClicked"
                }
            },
            cancelBtn:{
                type:Button,
                options:{
                    el: 'view.ui.cancelBtn',
                    permutation: Button.PERMUTATION.LINK,
                    initState: Button.STATES.ENABLED
                },
                events:{
                    "click":"onCancel"
                }
            }
        },

        onRender: function () {
            if (this.container) {
                this.container.append(this.$el);
            }

            this.ui.startDateInput.text(DateUtility.getDateToShow(this.selectedTimeframe.startDate));
            if (_.isNull(this.selectedTimeframe.expirationDate)) {
                this.ui.endDateInput.text("");
            } else {
                this.ui.endDateInput.text(DateUtility.getDateToShow(this.selectedTimeframe.expirationDate));
            }

            if(this.isEndDateCheckboxHidden){
                this.ui.endDateCheckBox.hide();

                //for now can't display both checkbox and max days label. don't have enough place
                if(this.maxDaysForTimeframeLabel){
                    this._setMaxDaysForTimeframeLabel(this.maxDaysForTimeframeLabel);
                }
            }
            else if(this.endDateCheckboxLabel){
                this._setNoEndDateCheckboxLabel(this.endDateCheckboxLabel);
            }

            if(this.allTimesCheckboxLabel){
                this.ui.allTimeCheckBox.text(this.allTimesCheckboxLabel);
            }

            if(this.alternativeSaveBtnText){
                this.uiComponents.saveBtn.setText(this.alternativeSaveBtnText);
            }

            if(this.isLimitFutureDates){
                this.uiComponents.endDatePicker.setMaxDate(new Date());
                this.uiComponents.startDatePicker.setMaxDate(new Date());
            }
            if(this.pastLimitDate){
                // limit the datePickers to this.pastLimitDate
                this.uiComponents.endDatePicker.setMinDate(this.pastLimitDate);
                this.uiComponents.startDatePicker.setMinDate(this.pastLimitDate);
            }
            if(this.timezoneId){
                this.ui.timezoneValue.text(this.timezoneId);
            } else {
                this.ui.timezoneContainer.hide();
            }

            if(!this.showButtons) {
                this.ui.timeframeContainer.addClass("no-buttons");
                this.ui.buttonsContainer.hide();
            }
        },

        _getEndDatePickerEnabledState: function(){
            return !_.isEmpty(this.selectedTimeframe.expirationDate);
        },

        _getNoEndDateChecked: function(){
            return _.isEmpty(this.selectedTimeframe.expirationDate);
        },

        _getAllTimeChecked: function(){
            return _.isEmpty(this.selectedTimeframe.startTime) && _.isEmpty(this.selectedTimeframe.endTime);
        },

        _getOperationHoursState: function(){
            return !(_.isEmpty(this.selectedTimeframe.startTime) && _.isEmpty(this.selectedTimeframe.endTime));
        },

        _getEndDatePickerMinDate: function(){
            if(this.isLimitEndDatePicker){
                return DateUtility.getMaxStrDate(this.selectedTimeframe.startDate, this.today);
            }
            return null;
        },

        _getStartDatePickerMaxDate: function(){
            if(this.isLimitStartDatePicker){
                return this.selectedTimeframe.expirationDate;
            }
            return null;
        },

        /**
         * Get the operation hours options.
         * keys: 00:00:00, 01:00:00, 02:00:00 ... 23:00:00
         * values: 12 am, 1 am, 2 am ... 11 pm
         * @return {Dropdown.Collection}
         * @private
         */
        _getHoursDropdownItems: function() {
            var hours = _.range(0, 24);
            var items = _.map(hours, function(number) {
                var key = (number > 9) ? number.toString() : "0" + number.toString();
                key = key + ":00:00";
                var ampmString = number < 12 ? "am" : "pm";
                var value;
                if (number === 0) {
                    value = "12:00 " + ampmString;
                }
                else if (number <= 12) {
                    value = number + ":00 " + ampmString;
                }
                else {
                    value = (number - 12) + ":00 " +ampmString;
                }
                return {key:key, value:value};
            });

            return new Dropdown.Collection(items);
        },

        _getEndTime: function(){
            return this._clearMinSec(this.selectedTimeframe.endTime);
        },

        _getStartTime: function(){
            return this._clearMinSec(this.selectedTimeframe.startTime);
        },

        _clearMinSec: function(time){
            return _.isEmpty(time) ? "00:00:00" : time.substring(0,2) + ":00:00";
        },

        _noEndDateChanged: function(componentId, eventName, checked) {
            this.uiComponents.endDatePicker.setEnabled(!checked);
            if (checked) {
                this.ui.endDateInput.text("");
                this.uiComponents.startDatePicker.setMaxDate(null);
            }
            else{
                if(_.isNull(this.selectedTimeframe.expirationDate)){
                    // Initialize the date to default expiration date (tomorrow) the date won't be save, unless the "no end date" checkbox will be unchecked.
                    this.selectedTimeframe.expirationDate =  DateUtility.getMaxStrDate(this.selectedTimeframe.startDate, this.tommorow) ;

                    this.uiComponents.endDatePicker.setSelectedDate(this.selectedTimeframe.expirationDate);
                }
                this.selectedTimeframe.expirationDate =  DateUtility.getMaxStrDate(this.selectedTimeframe.startDate, this.selectedTimeframe.expirationDate);
                this.ui.endDateInput.text(DateUtility.getDateToShow(this.selectedTimeframe.expirationDate));
                this.uiComponents.startDatePicker.setMaxDate(this.selectedTimeframe.expirationDate);
            }
        },

        _allTimeChanged: function(componentId, eventName, checked){
            this.uiComponents.fromTime.setEnabled(!checked);
            this.uiComponents.toTime.setEnabled(!checked);
        },

        _startDateChanged: function(componentId, eventName, dateAsStr){
            this.ui.startDateInput.text(DateUtility.getDateToShow(dateAsStr));
            this.selectedTimeframe.startDate = dateAsStr + " 00:00:00";
            if(this.isLimitEndDatePicker){
                this.uiComponents.endDatePicker.setMinDate(DateUtility.getMaxStrDate(dateAsStr, this.tommorow));
            }

            var startDate = DateUtility.strToDateObj(dateAsStr);
            //if the new startDate is later then the endDate then the endDate will be set to it (new startDate) meaning both set to the same date
            if(startDate > this.uiComponents.endDatePicker.getSelectedDate()){
                this._updatePickerDate(this.pickerLabelsEnum.END, startDate, dateAsStr);
            }
            //if there is maxDaysForTimeframeValue and the number of days between the new startDate and the endDate then the endDate
            //will be set to: startDate +(maxDaysForTimeframeValue-1)
            //+1 because the startDate is not counted in getDaysDiff.
            else if(this.maxDaysForTimeframeValue &&
                ((DateUtility.getDaysDiff(this.uiComponents.endDatePicker.getSelectedDate(), startDate)+1) > this.maxDaysForTimeframeValue) &&
                !_.isNull(componentId) &&  //null when we call the method as opposed to being called upon an event
                !_.isNull(eventName)){
                //-1 because the startDate is one more day
                var newDate = new Date(startDate.getTime());
                newDate.setDate(startDate.getDate() + (this.maxDaysForTimeframeValue-1));
                this._updatePickerDate(this.pickerLabelsEnum.END, newDate, DateUtility.date2Str(newDate, false));
            }
        },

        _endDateChanged: function(componentId, eventName, date){
            date = date.split(" ")[0]; // in case of sometimes it returns with the hour, but we don't need the hour as we concat 23:59:59.
            this.ui.endDateInput.text(DateUtility.getDateToShow(date));
            this.selectedTimeframe.expirationDate = date + " 23:59:59";
            if(this.isLimitStartDatePicker){
                this.uiComponents.startDatePicker.setMaxDate(date);
            }

            var endDate = DateUtility.strToDateObj(date);
            //if the new endDate is before startDate then the start date will be set to it (new endDate) meaning both set to the same date
            if(endDate < this.uiComponents.startDatePicker.getSelectedDate()){
                this._updatePickerDate(this.pickerLabelsEnum.START, endDate, date);
            }
            //if there is maxDaysForTimeframeValue and the number of days between the new endDate and the startDate then the startDate
            //will be set to: endDate -(maxDaysForTimeframeValue-1)
            //-1 because the endDate is one more day.
            else if(this.maxDaysForTimeframeValue &&
                ((DateUtility.getDaysDiff(endDate, this.uiComponents.startDatePicker.getSelectedDate())+1) > this.maxDaysForTimeframeValue) &&
                !_.isNull(componentId) &&  //null when we call the method as opposed to being called upon an event
                !_.isNull(eventName)){
                //-1 because teh startDate is one more day
                var newDate = new Date(endDate.getTime());
                newDate.setDate(endDate.getDate() - (this.maxDaysForTimeframeValue-1));
                this._updatePickerDate(this.pickerLabelsEnum.START, newDate, DateUtility.date2Str(newDate, false));
            }
        },

        _fromTimeChanged: function(componentId, eventName, ctx){
            this.selectedTimeframe.startTime = ctx.selectedKey;
        },

        _toTimeChanged: function(componentId, eventName, ctx){
            this.selectedTimeframe.endTime = ctx.selectedKey;
        },

        _updatePickerDate: function (pickerLabel, dateObj, dateStr){
            this["_" + pickerLabel + "DateChanged"](null, null, dateStr);
            this.uiComponents[pickerLabel +"DatePicker"].setSelectedDate(dateObj);
        },

        _setNoEndDateCheckboxLabel: function (label) {
            this.uiComponents.noEndDate.setCheckboxLabel(label);
        },

        _setMaxDaysForTimeframeLabel: function (label) {
            this.ui.maxDaysForTimeframeLabel.text(label);
        },

        getSelectedTimeframe: function() {
            return this.selectedTimeframe;
        },

        onSaveButtonClicked: function(){
            if(this.uiComponents.endDatePicker.isDisabled())
            {
                this.selectedTimeframe.expirationDate = null;
            }

            if(this.uiComponents.allTime.isChecked()){
                this.selectedTimeframe.startTime = null;
                this.selectedTimeframe.endTime = null;
            }
            else{
                this.selectedTimeframe.startTime = _.isEmpty(this.selectedTimeframe.startTime)? '00:00:00': this.selectedTimeframe.startTime;
                this.selectedTimeframe.endTime = _.isEmpty(this.selectedTimeframe.endTime)? '00:00:00': this.selectedTimeframe.endTime;
            }

            this.logger.debug("TimeFrameView:Save triggered","TimeFrame:onSaveButtonClicked");
            this.vent.trigger("TimeFrameView:Save", this.selectedTimeframe);
            this.trigger("TimeFrameView:Save", this.selectedTimeframe);
        },

        /**
         * Cancel event
         */
        onCancel: function () {
            this.logger.debug("TimeFrameView:onCancel event TimeFrameView:Cancel triggered ");
            this.vent.trigger("TimeFrameView:Cancel");
            this.trigger("TimeFrameView:Cancel");
        },

        onBeforeClose: function() {
            var uiComponents = this.uiComponents;

            if(_.isObject(uiComponents.allTime)){
                uiComponents.allTime.close();
            }

            if(_.isObject(uiComponents.toTime)){
                uiComponents.toTime.close();
            }

            if(_.isObject(uiComponents.fromTime)){
                uiComponents.fromTime.close();
            }

            if(_.isObject(uiComponents.noEndDate)){
                uiComponents.noEndDate.close();
            }

            if(_.isObject(uiComponents.startDatePicker)){
                uiComponents.startDatePicker.close();
            }

            if(_.isObject(uiComponents.endDatePicker)){
                uiComponents.endDatePicker.close();
            }

            this.uiComponents.saveBtn.close();
            this.uiComponents.cancelBtn.close();
            return true;
        },

        /**
         * Close event
         */
        onClose: function () {
            this.logger.debug("TimeFrameView:onClose");
        }

    });

    return TimeFrame;

});

